import React from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { strings } from "utils/constants/strings";
import { Loader } from "../../Common/Loader";
import { WhiteWrapper, Wrapper } from "../../Common/styles.common";
import BackButton from "../../Button/BackButton";
import DDPoCard from "./DDPoCard";
import { DDCompletedCard } from "./DDCompletedCard";
import { DD_PO_PAGES } from "./config";
import { DDPoPageTabs } from "./DDPoViewElements";

export default function AllDDPoViewMobile({
  activePage,
  pageConfig,
  hasNextPage,
  showLoader,
  purchaseOrders,
  handlePageChange,
  loadNextPage,
}) {
  let cards = [];
  if (activePage === DD_PO_PAGES.PENDING_INVOICE) {
    cards = purchaseOrders.map((po, index) => <DDPoCard key={index} po={po} source="all" />);
  } else if (activePage === DD_PO_PAGES.PENDING_DELIVERY) {
    cards = purchaseOrders.map((po, index) => <DDPoCard key={index} po={po} source="all" type="pending" />);
  } else if (activePage === DD_PO_PAGES.DELIVERED) {
    cards = purchaseOrders.map((po, index) => <DDCompletedCard key={index} po={po} />);
  }

  return (
    <Wrapper>
      <WhiteWrapper>
        <div className="d-flex align-items-center">
          <BackButton pathName="/" />
          <span className="fs-16 fw-600">{strings.allDDPoHeader}</span>
        </div>
      </WhiteWrapper>
      <div className="d-flex x-scroll">
        <DDPoPageTabs pageConfig={pageConfig} activePage={activePage} onChange={handlePageChange} />
      </div>
      {showLoader ? (
        <Loader />
      ) : (
        <InfiniteScroll
          className="infinite-scroll"
          height="75vh"
          dataLength={cards.length}
          hasMore={hasNextPage}
          next={loadNextPage}
          loader={<Loader isScrollLoader />}
        >
          {cards}
        </InfiniteScroll>
      )}
    </Wrapper>
  );
}
